/** US bill and coin denominations per cashier spec §4 */
export const BILL_DENOMINATIONS = [1, 2, 5, 10, 20, 50, 100] as const;
export const COIN_DENOMINATIONS = [0.01, 0.05, 0.1, 0.25, 0.5, 1.0] as const;
export const ALL_DENOMINATIONS = [...BILL_DENOMINATIONS, ...COIN_DENOMINATIONS] as const;

export type DenominationItem = {
  denomination: number;
  quantity: number;
};

export function emptyDenominationGrid(): DenominationItem[] {
  return ALL_DENOMINATIONS.map((denomination) => ({ denomination, quantity: 0 }));
}

export function computeDenominationTotal(items: DenominationItem[]): number {
  const total = items.reduce((sum, item) => sum + item.denomination * item.quantity, 0);
  return Math.round(total * 100) / 100;
}

export function formatDenominationLabel(value: number): string {
  if (value >= 1) return `$${value}`;
  return `$${value.toFixed(2)}`;
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}
